/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'app/components/common/Modal.jsx';
import Loading from 'app/components/common/Loading.jsx';
import { Breakpoint } from 'react-socks';

class UpgradeModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            version: ''
        };

        this.getGAPromoObject = this.getGAPromoObject.bind(this);
        this.closeUpgradeModal = this.closeUpgradeModal.bind(this);
        this.startUpgrade = this.startUpgrade.bind(this);
        this.getContent = this.getContent.bind(this);
        this.getIndex = this.getIndex.bind(this);
        this.setVersion = this.setVersion.bind(this);

    }

    getGAPromoObject() {

        let constants = this.props.app.config.constants,
            index = this.getIndex(),
            promo = {},
            type = (this.props.isFreeUser()) ? 'new' : 'upgrade',
            version = this.state.version;

        switch (index) {
            case 'outputs':
                promo.id = 'social_max';
                promo.name = 'Social Max';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'inputs':
                promo.id = 'feed_max';
                promo.name = 'Feed Max';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'twitterInput':
                promo.id = 'feed_twitter';
                promo.name = 'Feed Twitter';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'pinterestOutput':
                promo.id = 'social_pinterest';
                promo.name = 'Social Pinterest';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'queue':
                promo.id = 'queue_max';
                promo.name = 'Queue Max';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'users':
                promo.id = 'team';
                promo.name = 'Team';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'curation':
                promo.id = 'curate';
                promo.name = 'Curate';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'pullFreq':
                promo.id = 'feed_pull_freq';
                promo.name = 'Feed Pull Freq';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'unique':
                promo.id = 'social_second';
                promo.name = 'Social Second';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'feedOutput':
                promo.id = 'social_output_feed';
                promo.name = 'Social Output Feed';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'replay':
                promo.id = 'feed_echo';
                promo.name = 'Feed Echo';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'category':
                promo.id = 'category';
                promo.name = 'Category';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'everqueue':
                promo.id = 'everqueue';
                promo.name = 'EverQueue';
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'contentImport':
                promo.id = 'contentImport';
                promo.name = "Content Import";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'importConnections':
                promo.id = 'importConnections';
                promo.name = "Import Connections";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'staticHashtags':
                promo.id = 'staticHashtags';
                promo.name = "Static Hashtags";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'hashtagPool':
                promo.id = 'hashtagPool';
                promo.name = "Hashtag Pool";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'autoHashtags':
                promo.id = 'autoTopicTags';
                promo.name = "Auto Detected Hashtags";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'smartHashtags':
                promo.id = 'aiHashtags';
                promo.name = "AI Generated Hashtags";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'pushUpdates':
                promo.id = 'pushUpdates';
                promo.name = "PuSH Updates";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'clients':
                promo.id = 'clients';
                promo.name = "Add Client";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'clientSeatLimit':
                promo.id = 'clientSeatLimit';
                promo.name = "Add More Clients";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'apikey':
                promo.id = 'apikey';
                promo.name = "API Key";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'linkpage':
                promo.id = 'linkpage';
                promo.name = "Link Page";
                promo.creative = [promo.id, type, version].join(".");
                break;

            case 'postAnalyzer':
                promo.id = 'postAnalyzer';
                promo.name = "Post Analyzer";
                promo.creative = [promo.id, type, version].join(".");
                break;

            default:
                break;

        }

        promo.position = this.props.trigger;

        return promo;

    }

    componentDidMount() {

        if (typeof zE !== "undefined") {
            zE(function() {
                zE.hide();
            });
        }

        this.setVersion();
        this.props.getPlans();

    }

    setVersion() {
        if (this.props.user.detail.id !== undefined && this.state.version === "") {
            let version = "BLUE";
            // if (parseInt(this.props.user.id, 10) > 0) {
            //     version = (parseInt(this.props.user.id, 10) % 2) ? "GREEN" : "GREEN";
            // }

            this.setState({
                version: version
            }, () => {
                let promo = this.getGAPromoObject();

                if (mixpanel) {
                    mixpanel.track('Upgrade Prompt View', {
                        'id': promo.id,
                        'name': promo.name,
                        'creative': promo.creative,
                        'position': promo.position
                    });
                }

                if (this.props.recordEvent) {
                    this.props.recordEvent({
                        pub_id: this.props.user.detail.id,
                        event_name: 'Upgrade Prompt View',
                        event_data: {
                            promotion_id: promo.id,
                            promotion_name: promo.name
                        }
                    })
                }

                // if (dataLayer) {
                //     dataLayer.push({
                //         'event': 'promotionView',
                //         'ecommerce': {
                //             'promoView': {
                //                 'promotions': [
                //                     {
                //                         'id': promo.id,
                //                         'name': promo.name,
                //                         'creative': promo.creative,
                //                         'position': promo.position
                //                     }
                //                 ]
                //             }
                //         },
                //         //GA 4 params
                //         'promotion_id': promo.id,
                //         'promotion_name': promo.name,
                //         'creative_name': promo.creative,
                //         'creative_slot': promo.position,
                //         items: [
                //             {
                //                 item_id: 'dlvrit_1',
                //                 item_name: 'dlvr.it premium plan',
                //                 price: 1.00,
                //                 quantity: 1
                //             }
                //         ]
                //     });
                // }

                if (gtag) {
                    gtag('event', 'view_promotion', {
                        'promotion_id': promo.id,
                        'promotion_name': promo.name,
                        'creative_name': promo.creative,
                        'creative_slot': promo.position,
                        items: [
                            {
                                item_id: 'dlvrit_1',
                                item_name: 'dlvr.it premium plan',
                                price: 1.00,
                                quantity: 1
                            }
                        ]
                    });
                }
            });

        }

    }


    closeUpgradeModal() {

        this.props.modalHandler.apply(this, []);

    }

    startUpgrade(e) {
        let constants = this.props.app.config.constants,
            promo = this.getGAPromoObject(),
            redirector = () => {
                if (this.props.isFreeUser(this.props.user.detail.pubLevel)) {
                    if (['category', 'everqueue', 'contentImport', 'importConnections', 'hashtagPool', 'postAnalyzer'].indexOf(promo.id) !== -1) {
                        this.props.router.navigate('/account/subscription/new?plan=9');
                    } else if (['team', 'feed_max', 'social_max', 'social_output_feed', 'feed_pull_freq', 'feed_echo', 'staticHashtags', 'autoTopicTags', 'pushUpdates', 'clients', 'clientsSeatLimit', 'linkpage', 'apikey', 'aiHashtags'].indexOf(promo.id) !== -1) {
                        this.props.router.navigate('/account/subscription/new?plan=6');
                    } else {
                        this.props.router.navigate('/account/subscription/new');
                    }

                } else {
                    if (['category', 'everqueue', 'contentImport', 'importConnections', 'hashtagPool', 'postAnalyzer'].indexOf(promo.id) !== -1) {
                        this.props.router.navigate('/account/subscription/plus');
                    } else if (['feed_max', 'social_max'].indexOf(promo.id) !== -1) {
                        this.props.router.navigate('/account/subscription');
                    } else {
                        this.props.router.navigate('/account/subscription?change=true');
                    }
                }
            };

        e.preventDefault();
        e.stopPropagation();

        if (mixpanel) {
            mixpanel.track('Upgrade Prompt Click', {
                'id': promo.id,
                'name': promo.name,
                'creative': promo.creative,
                'position': promo.position
            });
        }

        // if (dataLayer && window.ga && ga.loaded) {
        //     dataLayer.push({
        //         'event': 'promotionClick',
        //         'ecommerce': {
        //             'promoClick': {
        //                 'promotions': [
        //                     {
        //                         'id': promo.id,
        //                         'name': promo.name,
        //                         'creative': promo.creative,
        //                         'position': promo.position
        //                     }
        //                 ]
        //             }
        //         },
        //         //GA 4 params
        //         'promotion_id': promo.id,
        //         'promotion_name': promo.name,
        //         'creative_name': promo.creative,
        //         'creative_slot': promo.position,
        //         items: [
        //             {
        //                 item_id: 'dlvrit_1',
        //                 item_name: 'dlvr.it premium plan',
        //                 price: 1.00,
        //                 quantity: 1
        //             }
        //         ]
        //     });
        // }

        if (gtag) {
            gtag('event', 'select_promotion', {
                'promotion_id': promo.id,
                'promotion_name': promo.name,
                'creative_name': promo.creative,
                'creative_slot': promo.position,
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });

            this.props.persistData('gaPromo', {
                'promotion_id': promo.id,
                'promotion_name': promo.name,
            });
        }

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Select Promotion',
                event_data: {
                    promotion_id: promo.id,
                    promotion_name: promo.name
                }
            })
        }

        redirector();

        this.props.closeAllModals(null);

    }

    getContent(index) {
        let contentRepository = {
            'inputs': {
                title: 'The :currentPlan comes with :currentFeedCount feeds',
                body: 'Upgrade to :nextPlan and easily share great content from up to :nextFeedCount feeds.',
                button: 'Get :nextPlan'
            },
            'inputs-plan': {
                title: 'Your current plan comes with :feeds feeds',
                body: 'Add a package of 10 socials and 50 feeds for an additional :price.',
                button: 'Expand Now'
            },
            'outputs': {
                title: 'The :currentPlan includes :socials social media pages',
                body: 'Upgrade to :nextPlan and connect all your social media pages.',
                button: 'Get :nextPlan'
            },
            'outputs-plan': {
                title: 'Your current plan comes with :socials Socials',
                body: 'Add a package of 10 socials and 50 feeds for an additional :price.',
                button: 'Expand Now'
            },
            'queue': {
                title: 'The :currentPlan includes :queueCount queued items per social.',
                body: 'Upgrade to :nextPlan and easily queue up to :nextQueueCount items per social.',
                button: 'Get :nextPlan'
            },
            'twitterInput': {
                title: 'Twitter inputs are not part of the :currentPlan',
                body: 'Upgrade to :nextPlan and easily share content from Twitter to all your socials.',
                button: 'Get :nextPlan'
            },
            'pinterestOutput': {
                title: 'Posting to Pinterest is not part of the :currentPlan',
                body: 'Upgrade to :nextPlan and easily share beautiful images on Pinterest.',
                button: 'Get :nextPlan'
            },
            'users': {
                title: 'The :currentPlan does not include team members.',
                body: 'Upgrade to Pro and share workload with two additional team members.',
                button: 'Get Pro'
            },
            'users-plan': {
                title: 'Your Current plan comes with 2 additional team members',
                body: 'Upgrade to the Agency plan and add up to 10 team members.',
                button: 'Get Agency'
            },
            'curation': {
                title: 'Curation is not part of your Legacy plan.',
                body: 'Get curation with a switch to any current dlvr.it plan.',
                button: 'Update plan'
            },
            'feedOutput': {
                title: 'Custom RSS Feeds are not part of the :currentPlan',
                body: 'Upgrade to Pro and easily share more great content to a custom rss feed.',
                button: 'Get Pro'
            },
            'unique': {
                title: 'Your plan includes one page per social network.',
                body: 'Upgrade to :nextPlan and connect multiple pages per social network.',
                button: 'Get :nextPlan'
            },
            'pullFreq': {
                title: 'The :currentPlan comes with 3 hour updates',
                body: "Upgrade to Pro and we'll check your feed for new items every 5 minutes",
                button: 'Get Pro'
            },
            'replay': {
                title: 'Your plan does not include Echo',
                body: "Go Pro and queue your posts for recycling days or weeks later for maximum traffic.",
                button: 'Get Pro'
            },
            'category': {
                title: 'Your plan does not include Category Manager',
                body: "Upgrade to Plus and customize posting schedules for all your content types.",
                button: 'Get Plus'
            },
            'everqueue': {
                title: 'Your plan does not include EverQueue',
                body: "Upgrade to Plus and effortlessly recycle your social media posts.",
                button: 'Get Plus'
            },
            'contentImport': {
                title: 'Your plan does not include Bulk Scheduler',
                body: "Upgrade to Plus and instantly schedule hundreds of posts from your favorite sources",
                button: 'Get Plus'
            },
            'importConnections': {
                title: 'Your plan does not include WordPress Scheduler',
                body: "Upgrade to Plus to import and schedule posts from your WordPress blog.",
                button: 'Get Plus'
            },
            'staticHashtags': {
                title: 'Your plan does not include Static Hashtags',
                body: "Upgrade to Pro and automatically include hashtags in every post.",
                button: 'Get Pro'
            },
            'hashtagPool': {
                title: 'Your plan does not include Dynamic Hashtag Pool',
                body: "Upgrade to Plus and automatically add hashtags to each post from your hashtag pool.",
                button: 'Get Plus'
            },
            'autoHashtags': {
                title: 'Your plan does not include Auto Detected Hashtags',
                body: "Upgrade to Pro and we'll automatically detect and add hashtags to every post.",
                button: 'Get Pro'
            },
            'smartHashtags': {
                title: 'Your plan does not include Smart Hashtags',
                body: "Upgrade to Pro and our AI powered hashtag tool can generate relevant hashtags for every post.",
                button: 'Get Pro'
            },
            'pushUpdates': {
                title: 'The :currentPlan comes with 3 hour updates',
                body: "Upgrade to Pro and we'll instantly post your PuSH enabled feed updates.",
                button: 'Get Pro'
            },
            'clients': {
                title: 'Have your customers connect their social pages',
                body: "Post for your customers without managing their logins and passwords.",
                button: 'Get Pro'
            },
            'clientSeatLimit': {
                title: "You've reached your maximum number of clients",
                body: "Contact us to add more.",
                button: 'Get Pro'
            },
            'linkpage': {
                title: 'The :currentPlan does not include Link Pages',
                body: "Turn Instagram posts into a clickable Bio Link Page and drive traffic.",
                button: 'Get Pro'
            },
            'apikey': {
                title: 'The :currentPlan does not include API access',
                body: "Get an API key and hook dlvr.it into your own custom workflow.",
                button: 'Get Pro'
            },
            'postAnalyzer': {
                title: 'The :currentPlan does not include the Post Analyzer',
                body: "Get valuable insights and quickly repost your most popular content.",
                button: 'Get Plus'
            }
        };

        return (contentRepository[index]) ? Object.assign({}, contentRepository[index]) : {};
    }

    getIndex() {
        let index = '',
            constants = this.props.app.config.constants;

        if (this.props.context === 'socials' || this.props.errorCode == constants.P_SOCIAL_LIMIT) {
            index = 'outputs';
        } else if (this.props.context == 'inputs' || this.props.errorCode == constants.P_INPUT_LIMIT) {
            index = 'inputs';
        } else if (this.props.context == 'twitterInput' || this.props.errorCode == constants.P_INPUT_RESTRICTION) {
            index = 'twitterInput';
        } else if (this.props.context == 'pinterest' || this.props.errorCode == constants.P_SOCIAL_RESTRICTION) {
            index = 'pinterestOutput';
        } else if (this.props.context == 'queue' || this.props.errorCode == constants.P_QUEUE_LIMIT) {
            index = 'queue';
        } else if (this.props.context == 'users' || this.props.errorCode == constants.P_SUB_RESTRICTION) {
            index = 'users';
        } else if (this.props.context == 'usersLimit' || this.props.errorCode == constants.P_SUB_LIMIT) {
            index = 'users-plan';
        } else if (this.props.context == 'clients' || this.props.errorCode == constants.P_CLIENT_ACCTS) {
            index = 'clients';
        } else if (this.props.context == 'clientSeatLimit' || this.props.errorCode == constants.P_CLIENT_ACCT_LIMIT) {
            index = 'clientSeatLimit';
        } else if (this.props.context == 'curation' || this.props.errorCode == constants.P_CURATION) {
            index = 'curation';
        } else if (this.props.context == 'pullFreq' || this.props.errorCode == constants.P_PULLFREQ_RESTRICTION) {
            index = 'pullFreq';
        } else if (this.props.context == 'postLimit' || this.props.errorCode == constants.P_POSTLIMIT_RESTRICTION) {
            index = '';
        } else if (this.props.context == 'unique' || this.props.errorCode == constants.P_SOCIAL_MULTI) {
            index = 'unique';
        } else if (this.props.context == 'feedOutput' || this.props.errorCode == constants.P_SOCIAL_RESTRICTION) {
            index = 'feedOutput';
        } else if (this.props.context == 'replay' || this.props.errorCode == constants.P_REPEAT_POST) {
            index = 'replay';
        } else if (this.props.context == 'category' || this.props.errorCode == constants.P_CATEGORIES) {
            index = 'category';
        } else if (this.props.context == 'everqueue' || this.props.errorCode == constants.P_EVERQ) {
            index = 'everqueue';
        } else if (this.props.context == 'contentImport' || this.props.errorCode == constants.P_BULK_IMPORT) {
            index = 'contentImport';
        } else if (this.props.context == 'importConnections' || this.props.errorCode == constants.P_GENERIC_ACCTS) {
            index = 'importConnections';
        } else if (this.props.context == 'staticHashtags' || this.props.errorCode == constants.P_HASH_STATIC) {
            index = 'staticHashtags';
        } else if (this.props.context == 'hashtagPool' || this.props.errorCode == constants.P_HASH_POOL) {
            index = 'hashtagPool';
        } else if (this.props.context == 'autoHashtags' || this.props.errorCode == constants.P_AUTO_HASH) {
            index = 'autoHashtags';
        } else if (this.props.context == 'pushUpdates' /*|| this.props.errorCode == constants.P_AUTO_HASH*/) {
            index = 'pushUpdates';
        }  else if (this.props.context === 'linkpage') {
            index = "linkpage";
        } else if (this.props.errorCode === constants.P_APIKEYS) {
            index = "apikey";
        } else if (this.props.context == 'smartHashtags' || this.props.errorCode == constants.P_AI_HASH) {
            index = "smartHashtags";
        } else if (this.props.context === 'postAnalyzer') {
            index = 'postAnalyzer';
        }

        return index;

    }

    render() {
        let imageUrl = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl,
            content = null,
            title = "Mmmmm. Smells like an upgrade.",
            constants = this.props.app.config.constants,
            index = '',
            copy = null,
            body = '',
            subFooterClass = 'pro-features',
            mainClass = "upgrade",
            modalContent = null,
            cta = null,
            isAgent = this.props.user.detail.isAgent;

        const searchAndReplace = (copy) => {
            let keys = Object.keys(copy),
                that = this;

            keys.map((key) => {
                let constants = that.props.app.config.constants;

                if (copy[key].match(":socials")) {
                    copy[key] = copy[key].replace(":socials", that.props.user.perms.perms.hardLimitOutputs);
                }
                if (copy[key].match(":feeds")) {
                    copy[key] = copy[key].replace(":feeds", that.props.user.perms.perms.hardLimitInputs);
                }
                if (copy[key].match(":price") && !isAgent) {
                    if (parseInt(that.props.user.plan.planTerm, 10) === constants.SUBSCRIPTION_TERM_MONTHLY) {
                        copy[key] = copy[key].replace(":price", "$" + constants.SUBSCRIPTION_ADDON_PRICES[that.props.user.detail.pubLevel][constants.SUBSCRIPTION_TERM_MONTHLY][constants.SUBSCRIPTION_ADDON_SOCIALS].toFixed(2) + " / month");
                    } else {
                        copy[key] = copy[key].replace(":price", "$" + constants.SUBSCRIPTION_ADDON_PRICES[that.props.user.detail.pubLevel][constants.SUBSCRIPTION_TERM_ANNUAL][constants.SUBSCRIPTION_ADDON_SOCIALS].toFixed(2) + " / year");
                    }
                } else if (copy[key].match(":price") && isAgent) {
                    // go generic on 'em
                    copy[key] = copy[key].replace(":price", "cost");
                }

                let currentPlan = that.props.plans.details[that.props.user.detail.pubLevel],
                    nextPlan = null;
                if (that.props.isFreeUser()) {
                    nextPlan = that.props.plans.details[constants.PUB_LEVEL_15];
                    if (copy[key].match(":currentPlan")) {
                        copy[key] = copy[key].replace(":currentPlan", "free trial");
                    }
                    if (key === "body" && index === "outputs") {
                        copy[key] = "Upgrade to Pro and connect 10 social media pages";
                    }
                    if (key === "body" && index === "inputs") {
                        copy[key] = `Upgrade to Pro and easily share great content from up to ${that.props.plans.details[constants.PUB_LEVEL_6].limits.hardLimitInputs} feeds.`
                    }
                    if (key == "button" && (index === "inputs" || index === "outputs")) {
                        copy[key] = 'Get Pro';
                    }
                    if (copy[key].match(":nextPlan")) {
                        copy[key] = copy[key].replace(":nextPlan", `${nextPlan.label}`);
                    }
                } else if (that.props.isStarterUser()) {
                    nextPlan = that.props.plans.details[constants.PUB_LEVEL_15];
                    if (key === "body" && index === "outputs") {
                        copy[key] = "Upgrade to Basic and connect 3 social media pages";
                    }
                    if (copy[key].match(":currentPlan")) {
                        copy[key] = copy[key].replace(":currentPlan", `${currentPlan.label} plan`);
                    }
                    if (copy[key].match(":nextPlan")) {
                        copy[key] = copy[key].replace(":nextPlan", `${nextPlan.label}`);
                    }
                } else {
                    nextPlan = that.props.plans.details[constants.PUB_LEVEL_6];
                    if (copy[key].match(":currentPlan")) {
                        copy[key] = copy[key].replace(":currentPlan", `${currentPlan.label} plan`);
                    }
                    if (copy[key].match(":nextPlan")) {
                        copy[key] = copy[key].replace(":nextPlan", `${nextPlan.label}`);
                    }
                }

                if (copy[key].match(":currentFeedCount")) {
                    copy[key] = copy[key].replace(":currentFeedCount", currentPlan.limits.hardLimitInputs);
                }
                if (copy[key].match(":nextFeedCount")) {
                    copy[key] = copy[key].replace(":nextFeedCount", nextPlan.limits.hardLimitInputs);
                }
                if (copy[key].match(":queueCount")) {
                    copy[key] = copy[key].replace(":queueCount", that.props.user.perms.resources.qLimit);
                }
                if (copy[key].match(":nextQueueCount")) {
                    copy[key] = copy[key].replace(":nextQueueCount", nextPlan.limits.qDirectMax);
                }
            });
        }

        index = this.getIndex();

        if (!this.props.isFreeUser() &&
            !this.props.isStarterUser() &&
            !this.props.isBasicUser() &&
             (index === 'inputs' || index === 'outputs')) {
            index += "-plan";
        }

        if (this.state.version === "GREEN") {
            mainClass += " green-version";
        } else if (this.state.version === "BLUE") {
            mainClass += " blue-version";
        }

        if (this.props.user.detail.trialEligible) {
            subFooterClass += ' large';
        }

        if (Object.keys(this.props.plans.details).length) {
            copy = this.getContent(index);

            if (Object.keys(copy).length === 0) {
                // if there's no copy, it's possible this is being called in error, bail until the situation
                // is better resolved by upstream code (which will send an explicit context or error code that matches)
                return;
            }

            searchAndReplace(copy);

            if (index == 'inputs-plan' || index == 'outputs-plan') {
                if (this.props.isPlusUser()) {
                    copy.body = copy.body.replace("10 socials", "5 socials");
                    copy.body = copy.body.replace("50 feeds", "25 feeds");
                }
            }

            let versionClass = (this.state.version === 'GREEN') ? 'green-version' : 'blue-version';
            if (isAgent) {
                cta = (
                    <button className={`continue-upgrade ${versionClass}`} onClick={this.closeUpgradeModal}>
                        Contact the account owner to upgrade
                    </button>
                );
            } else if (this.props.showCTA) {
                cta = (
                    <button className={`continue-upgrade ${versionClass}`} onClick={this.startUpgrade}>
                        {copy.button}
                    </button>
                );
            } else if (this.props.showCTA === false && (index === 'clients' || index === 'clientSeatLimit')) {
                cta = (
                    <button className={`continue-upgrade ${versionClass}`} onClick={() => {
                            window.location.href = 'mailto:support@dlvr.it';
                            this.props.closeAllModals();
                        }}>
                        Contact Us
                    </button>
                );
            }
            content = (
                <div>
                    <div className={`dlvr-upgrade-body ${versionClass}`}>
                        <Breakpoint desktop only>
                            <div className="more-stuff">
                                {copy.body}
                            </div>
                        </Breakpoint>
                        <Breakpoint mobile only>
                            <div className="mobile-title">
                                {copy.title}
                            </div>
                            <div className="more-stuff">
                                {copy.body}
                            </div>
                        </Breakpoint>
                        {cta}
                    </div>
                </div>
            );

        } else {
            content = (
                <Loading/>
            );
        }

        modalContent = (
            <div>
                <Breakpoint desktop only>
                    <Modal
                        headerContent={(copy) ? copy.title : null}
                        mainClass={mainClass}
                        content={content}
                        close={this.closeUpgradeModal}
                        hasBackground={this.props.hasBackground}
                        wrapperClass="upgrade-modal"/>
                </Breakpoint>
                <Breakpoint mobile only>
                    <Modal
                        headerContent={null}
                        mainClass={mainClass}
                        content={content}
                        close={this.closeUpgradeModal}
                        hasBackground={this.props.hasBackground}
                        wrapperClass="mobile-upgrade"/>
                </Breakpoint>
            </div>
        );

        return modalContent;
    }

};

UpgradeModal.displayName = "UpgradeModal";

UpgradeModal.propTypes = {
    showCTA: PropTypes.bool
};

UpgradeModal.defaultProps = {
    showCTA: true
};

export default UpgradeModal;
